import React, { useState } from "react";
import { Card, Button, message, Spin, Modal, Form, Input } from "antd";
import EndpointFunctions from "../../../utils/Functions/endpointFunctions";
import Endpoints from "../../../api/endpoints";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

const PersonnelList = ({ shop, onSuccess }) => {
  const axiosPrivate = useAxiosPrivate();
  const [loading, setLoading] = useState(false);
  const [processingId, setProcessingId] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [addLoading, setAddLoading] = useState(false);

  const handleStatusChange = async (shopDeviceId, currentStatus) => {
    setProcessingId(shopDeviceId);
    setLoading(true);
    const endpointURL =
      currentStatus === 1
        ? Endpoints.passivatePersonnel
        : Endpoints.activatePersonnel;
    const response = await EndpointFunctions.putData({
      endpointURL: `${endpointURL}/${shopDeviceId}`,
      axiosPrivate: axiosPrivate,
    });

    if (response.success) {
      message.success("Personel durumu güncellendi");
      if (onSuccess) {
        onSuccess();
      }
    } else {
      message.error("Personel durumu güncellenemedi");
    }
  };

  const handleAddPersonnel = async (values) => {
    setAddLoading(true);
    try {
      const response = await EndpointFunctions.postData({
        endpointURL: Endpoints.addPersonnel,
        axiosPrivate: axiosPrivate,
        requestBody: {
          shopId: shop.shopDetails.id,
          deviceName: values.deviceName,
        },
      });

      if (response.success) {
        message.success("Personel başarıyla eklendi");
        setIsModalVisible(false);
        form.resetFields();
        if (onSuccess) {
          onSuccess();
        }
      } else {
        message.error("Personel eklenemedi");
      }
    } catch (error) {
      message.error("Bir hata oluştu");
    } finally {
      setAddLoading(false);
    }
  };

  return (
    <Card
      type="inner"
      style={{ marginTop: 16 }}
      title="Personel Listesi"
      extra={
        <Button type="primary" onClick={() => setIsModalVisible(true)}>
          Personel Ekle
        </Button>
      }>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ padding: "8px", borderBottom: "1px solid #f0f0f0" }}>
              ID
            </th>
            <th style={{ padding: "8px", borderBottom: "1px solid #f0f0f0" }}>
              Cihaz ID
            </th>
            <th style={{ padding: "8px", borderBottom: "1px solid #f0f0f0" }}>
              Cihaz Adı
            </th>
            <th style={{ padding: "8px", borderBottom: "1px solid #f0f0f0" }}>
              Durum
            </th>
            <th style={{ padding: "8px", borderBottom: "1px solid #f0f0f0" }}>
              Son Aktivite
            </th>
            <th style={{ padding: "8px", borderBottom: "1px solid #f0f0f0" }}>
              İşlem
            </th>
          </tr>
        </thead>
        <tbody>
          {shop?.shopPersonnelDetails.map((personnel) => (
            <tr key={personnel.id}>
              <td style={{ padding: "8px", borderBottom: "1px solid #f0f0f0" }}>
                {personnel.id}
              </td>
              <td style={{ padding: "8px", borderBottom: "1px solid #f0f0f0" }}>
                {personnel.shopDeviceId}
              </td>
              <td style={{ padding: "8px", borderBottom: "1px solid #f0f0f0" }}>
                {personnel.deviceName}
              </td>
              <td style={{ padding: "8px", borderBottom: "1px solid #f0f0f0" }}>
                {personnel.status === 1 ? "Aktif" : "Pasif"}
              </td>
              <td style={{ padding: "8px", borderBottom: "1px solid #f0f0f0" }}>
                {personnel.lastActivity || "-"}
              </td>
              <td style={{ padding: "8px", borderBottom: "1px solid #f0f0f0" }}>
                <Button
                  type={personnel.status === 1 ? "default" : "primary"}
                  onClick={() =>
                    handleStatusChange(personnel.shopDeviceId, personnel.status)
                  }
                  loading={loading && processingId === personnel.id}>
                  {personnel.status === 1 ? "Pasif Et" : "Aktif Et"}
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Modal
        title="Personel Ekle"
        open={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          form.resetFields();
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setIsModalVisible(false);
              form.resetFields();
            }}>
            İptal
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={addLoading}
            onClick={() => form.submit()}>
            Ekle
          </Button>,
        ]}>
        <Form form={form} layout="vertical" onFinish={handleAddPersonnel}>
          <Form.Item
            name="deviceName"
            label="Cihaz Adı"
            rules={[
              {
                required: true,
                message: "Lütfen cihaz adı giriniz",
              },
            ]}>
            <Input placeholder="Cihaz adını giriniz" />
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
};

export default PersonnelList;
